import {
  getDateFromSeconds,
  getDateInFormat,
  MONTH_DAY_FORMAT
} from "@/helpers/date.helpers"

export const DISCOVERED_CLOSED_ISSUES_MAX = 1000

export const getDefaultLabelFormatterForXAxis = () => {
  return {
    tickCount: 4,
    label: {
      formatter: (timestampSeconds: string) =>
        getDateInFormat(
          getDateFromSeconds(Number(timestampSeconds)),
          MONTH_DAY_FORMAT
        )
    }
  }
}
